export default "__VITE_ASSET__4516be2b__"